import React from 'react';
import { EMERGENCY_NUMBER } from '../config/site';
import Icon from './Icon';

/** Thin bar above the header on every page: the fastest path to emergency help. */
const SosStrip: React.FC = () => (
  <div className="sos-strip" data-inert-when-menu role="region" aria-label="Emergencias">
    <div className="container sos-strip__inner">
      <p>¿En peligro ahora?</p>
      <a className="sos-strip__call" href={`tel:${EMERGENCY_NUMBER}`}>
        <Icon name="phone" />
        Llamar al {EMERGENCY_NUMBER}
      </a>
    </div>
  </div>
);

export default SosStrip;
